import request from './request'
import { Message } from 'element-ui'

/**
 * 下载文件
 * @param response
 */
export function downloadFile(response) {
  const resData = response.data
  const fileReader = new FileReader()
  fileReader.onloadend = () => {
    if (resData.type === 'application/json') {
      const data = JSON.parse(fileReader.result)
      Message({
        message: data.message || 'Error',
        type: 'error',
        duration: 5 * 1000
      })
    } else {
      // 下载文件
      let contentDisposition = response.headers['content-disposition']
      let fileName = contentDisposition.substring(contentDisposition.indexOf('filename=') + 9)
      let blob = new Blob([response.data], {
        type: 'application/vnd.ms-excel'
      })

      let link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = decodeURIComponent(fileName)
      link.click()
      // 释放内存
      window.URL.revokeObjectURL(link.href)
    }
  }
  fileReader.readAsText(resData)
}

/**
 * 上传文件
 * @param url
 * @param form
 */
export function uploadFile(url, form) {
  return request({
    url,
    method: 'post',
    data: form,
    headers: { 'Content-Type': 'multipart/form-data' }
  })
}
